import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

const HtmlContent = ({ html, className }) => {
  return <div className={clsx('hint-html-injected', className)} dangerouslySetInnerHTML={{ __html: html }} />
}

export default HtmlContent

HtmlContent.propTypes = {
  html: PropTypes.string,
  className: PropTypes.string
}
